"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M17.1 10.104c0-1.602-.67-3.054-1.75-4.104l-.864.839a4.538 4.538 0 011.393 3.265c0 2.55-2.129 4.618-4.754 4.618-1.313 0-2.5-.516-3.362-1.352l-.863.839a6.036 6.036 0 003.806 1.686v.919H8.264V18h6.105v-1.186h-2.442v-.957c2.92-.38 5.173-2.811 5.173-5.753z" }),
    React.createElement("path", { d: "M7.653 9.993c0-1.801 1.503-3.262 3.358-3.262 1.855 0 3.358 1.46 3.358 3.262s-1.504 3.262-3.358 3.262c-1.855 0-3.358-1.46-3.358-3.262z" })), "Localization");
//# sourceMappingURL=Localization.js.map